import { Icon } from "./Icons";

export type Screen = "map" | "journey" | "fellowship" | "walker";
const ITEMS: [Screen, string, string][] = [["map", "Map", "nav-map"], ["journey", "Journey", "nav-journal"], ["fellowship", "Fellowship", "nav-fellowship"], ["walker", "Walker", "nav-profile"]];

export default function BottomNav({ screen, onChange }: { screen: Screen; onChange: (s: Screen) => void }) {
  return (
    <nav className="nav" aria-label="Main">
      {ITEMS.map(([id, label, icon]) => (
        <button key={id} className={screen === id ? "nav-btn active" : "nav-btn"} onClick={() => onChange(id)} aria-current={screen === id ? "page" : undefined}>
          <Icon id={icon} size={22} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
